import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";
import moment from 'moment'

Vue.use(Vuex);

const STATE_UNLOADED = 0;
const STATE_LOADING = 1;
const STATE_LOADED = 2;

export const store = new Vuex.Store({
  mutations: {
  },
  actions: {
  },
  getters: {
  }
})